let descriptionContainer = document.querySelector('.collection-hero__description_container');


if (descriptionContainer) {
    let moreLessBtn = descriptionContainer.querySelectorAll('.more-less-btn')
    moreLessBtn.forEach( (btn) => {
        btn.addEventListener('click', (e) => {
            if (e.target.classList.contains('description-read-more')) {
                descriptionContainer.querySelector('.collection-hero_desc-wrapper.collection-hero__description_excerpt').classList.add('hide-description-element')
                descriptionContainer.querySelector('.collection-hero_desc-wrapper.collection-hero__description').classList.remove('hide-description-element')
            }

            if (e.target.classList.contains('description-read-less')) {
                descriptionContainer.querySelector('.collection-hero_desc-wrapper.collection-hero__description_excerpt').classList.remove('hide-description-element')
                descriptionContainer.querySelector('.collection-hero_desc-wrapper.collection-hero__description').classList.add('hide-description-element')
            }
        })
    })

}
